export default __webpack_public_path__ + "static/media/profile_image_placeholder.275ce544.png";